import { memo } from "react";
import { cn } from "../../../utils/cn";
import TextInputPermitPDF from "../../inputs/TextInputPermitPDF";

interface PermitDetailsProps {
    permitDetails: {
        s_ExitBuilding: string;
        s_EntryBuilding: string;
        s_EscortingEmployeeName: string;
        s_PermitDescriptionCode_En: string;
        s_PermitDescriptionOthersValue: string;

        haveUserCard: boolean;
    };
}

const PermitDetails = ({
    permitDetails,
}: PermitDetailsProps) => {
    return (
        <div>
            <div className="bg-green-primary text-center border-b border-black py-0.5">
                <span className="text-[10px] font-bold text-white">
                    Section 1: Permit Details
                </span>
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Exit Building:"
                    value={permitDetails?.s_ExitBuilding || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="Entry Building:"
                    value={permitDetails?.s_EntryBuilding || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>

            <div className="grid grid-cols-2">
                <TextInputPermitPDF
                    label="Escorting Employee:"
                    value={permitDetails?.s_EscortingEmployeeName || ""}
                    labelStyles="border-r border-b w-[40%]"
                    valueStyles="border-r border-b w-[60%]"
                />
                <TextInputPermitPDF
                    label="General Description:"
                    value={permitDetails?.s_PermitDescriptionOthersValue || permitDetails?.s_PermitDescriptionCode_En || ""}
                    labelStyles="border-r border-b w-[30%]"
                    valueStyles="border-b w-[70%]"
                />
            </div>
        </div>
    );
};

export default memo(PermitDetails);
